var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VideoSlide',{attrs:{"src":require('@/assets/videos/B-A-005_SAF_BTB_PhishingInAction.mp4'),"vtt":require('@/assets/videos/B-A-005_SAF_BTB_PhishingInAction.vtt'),"background-theme":"dark"}})
}
var staticRenderFns = []

export { render, staticRenderFns }